const SvgIcon = ({size = '24', color = '#fff'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="1.819"
      d="M22.728.055c-.288-.08-.6-.077-.907.034L1.107 7.176C.44 7.404.017 8.063 0 8.682c-.015.619.373 1.299 1.027 1.561l8.654 3.469c.276.11.496.329.607.606l3.469 8.653v.002c.262.654.943 1.042 1.561 1.027.619-.016 1.278-.44 1.506-1.107l7.087-20.715c.333-.922-.318-1.886-1.183-2.123m-1.236 2.453-6.255 18.287-2.924-7.29a3.28 3.28 0 0 0-1.82-1.818L3.204 8.764Z"
      color={color}
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="1.819"
      d="M22.755.154a1.1 1.1 0 0 0-.77.32L10.046 12.41a1.09 1.09 0 0 0 0 1.544 1.09 1.09 0 0 0 1.543 0L23.526 2.018a1.09 1.09 0 0 0 0-1.544 1.1 1.1 0 0 0-.77-.32"
      color={color}
    ></path>
  </svg>
);

export default SvgIcon;
